/**
 * Build the deep link the partnership QR code carries, so a phone's system camera opens the
 * native app directly on the partner-connect route. The scheme is the one
 * apps/native/app.config.ts registers; the path is the native join-organization code route,
 * which posts the code to /organizations/connect.
 *
 * @param code - The full partnership invitation code, check id included (e.g. "AHPL-10000001").
 * @returns The suite-native deep link for the given code.
 */
export function getPartnerConnectLink(code: string): string {
	return `suite-native://app/settings/join-organization/${code}`;
}
